import React, { useState, useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { toast } from "react-toastify";
import TrackMatchingVideo from "@/pages/TrackMatching/TrackMatchingVideo";
import { internApi, matchApi } from "@/api";
import Preloader from "@/components/Elements/Preloader";

const TrackMatching = () => {
  const [videoUrl, setVideoUrl] = useState(null);
  const [task, setTask] = useState(null);
  const [selectedTrackId, setSelectedTrackId] = useState("");
  const [pipeConflictId, setPipeConflictId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  async function fetchMatchTask() {
    try {
      const res = await internApi.getMatchTask("track");
      const { id, match_number, task } = res;
      const { url } = await matchApi.getFilePath({
        matchId: match_number,
        fileType: "study_video",
      });
      setPipeConflictId(id);
      setVideoUrl(url);
      setTask(task);
    } catch (err) {
      console.log(err);
      if (err.response?.status === 404) {
        toast.warn("No more tasks.");
      } else {
        toast.error("Something went wrong.");
      }
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchMatchTask();
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [selectedTrackId, pipeConflictId]);

  const onKeyDown = async (e) => {
    const { code } = e;
    if (code === "Enter" || code === "KeyW") {
      e.preventDefault();
      await sendResult();
    } else if (code === "KeyA") {
      await sendResult(true);
    }
  };

  const updateSelectedTrack = (trackId) => {
    setSelectedTrackId(trackId);
  };

  const sendResult = async (isDelete = false) => {
    try {
      await internApi.postMatchTask(
        pipeConflictId,
        isDelete ? -1 : selectedTrackId,
        "track"
      );
      if (isDelete) {
        toast.success("Successfully deleted the track.");
      } else {
        toast.success("Successfully submitted the selected track.");
      }
      fetchMatchTask();
    } catch (err) {
      toast.error("Something went wrong while submitting the result.");
    }
  };

  return (
    <>
      {isLoading ? (
        <Preloader className="m-auto" />
      ) : (
        <Container className="py-4" fluid>
          {videoUrl && task ? (
            <>
              <Row>
                <Col>
                  <TrackMatchingVideo
                    src={videoUrl}
                    task={task}
                    selectedTrack={selectedTrackId}
                    updateSelectedTrack={updateSelectedTrack}
                  />
                </Col>
              </Row>
              <Row className="justify-content-center mt-2">
                <Col xs={"auto"}>
                  <Button onClick={() => sendResult(false)}>
                    {selectedTrackId ? "Submit selection" : "No required track"}
                  </Button>

                  <Button
                    className={"mx-2"}
                    variant="outline-primary"
                    onClick={() => sendResult(true)}
                  >
                    Delete track
                  </Button>
                </Col>
              </Row>
            </>
          ) : (
            <div className="d-flex justify-content-center">
              There is no available tasks.
            </div>
          )}
        </Container>
      )}
    </>
  );
};

export default TrackMatching;
